import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DocumentTypeFederalRegisterItems } from './documenttypefederalregisteritems';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { DocumenttypefederalregisteritemsService } from './documenttypefederalregisteritems.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

declare var $: any;
@Component({
  selector: 'app-documenttypefederalregisteritems',
  templateUrl: './documenttypefederalregisteritems.component.html',
  styleUrls: ['./documenttypefederalregisteritems.component.css']
})
export class DocumenttypefederalregisteritemsComponent implements OnInit {

  sendMenuId: number;
  sendPageName: string = 'DocumentTypeFederalRegisterItems';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;
  documenttypefederalregisteritemsForm: FormGroup;
  documenttypefederalregisteritemss: DocumentTypeFederalRegisterItems[] = [];
  documenttypefederalregisteritemssactive: DocumentTypeFederalRegisterItems[] = [];
  documenttypefederalregisteritems: DocumentTypeFederalRegisterItems;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  documenttypefederalregisteritemsModalRef: BsModalRef;
  operation: string;
  userid: number;
  documenttypefederalregisteritemsid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  key: string = 'documenttypefederalregisteritems'; //set default
  reverse: boolean = false;

  constructor(
    private documenttypefederalregisteritemsservice: DocumenttypefederalregisteritemsService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      // console.log(this.router.getCurrentNavigation().extras.state);
      localStorage.setItem('DocumentTypeFederalRegisterItems_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('DocumentTypeFederalRegisterItems_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('DocumentTypeFederalRegisterItems_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('DocumentTypeFederalRegisterItems_action');
    }
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    this.documenttypefederalregisteritemsForm = this.formBuilder.group({
      documenttypefederalregisteritemsid: [''],
      documenttypefederalregisteritems: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  getactiveinactive(showallp) {
    this.documenttypefederalregisteritemssactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.documenttypefederalregisteritemss.forEach(data => {
        if (data.active == 1) {
          this.documenttypefederalregisteritemssactive.push(data);
        }
      });
      this.documenttypefederalregisteritemss = [];
      this.documenttypefederalregisteritemss = this.documenttypefederalregisteritemssactive;
    }
    else {
      this.showall = true;
      this.documenttypefederalregisteritemss = [];
      this.getAll();
    }
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizeddocumenttyperegisteritems");
    let data = arrays.find(ob => ob['name'] === 'Document Type Federal Register Items');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizeddocumenttyperegisteritems","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizeddocumenttyperegisteritems",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.documenttypefederalregisteritemsModalRef.hide();
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.documenttypefederalregisteritemss = [];
    this.documenttypefederalregisteritemssactive = [];
    this.documenttypefederalregisteritemsservice.Get().subscribe(res => {
      this.documenttypefederalregisteritemss = res;
      if (this.showallstatus == true) {
        this.documenttypefederalregisteritemss.forEach(data => {
          if (data.active == 1) {
            this.documenttypefederalregisteritemssactive.push(data);
          }
        });
        this.documenttypefederalregisteritemss = [];
        this.documenttypefederalregisteritemss = this.documenttypefederalregisteritemssactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  get g() { return this.documenttypefederalregisteritemsForm.controls; }

  Post(documenttypefederalregisteritems: DocumentTypeFederalRegisterItems) {

    this.submitted = true;
    // stop here if form is invalid
    //if (this.documenttypefederalregisteritemsForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.documenttypefederalregisteritemsForm.errors);
    //}

    if ((documenttypefederalregisteritems.documenttypefederalregisteritems.trim() == undefined) || (documenttypefederalregisteritems.documenttypefederalregisteritems.trim() == '')) {
      this.toastr.error('DocumentTypeFederalRegisterItems should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    documenttypefederalregisteritems.documenttypefederalregisteritems = documenttypefederalregisteritems.documenttypefederalregisteritems.trim();
    if (this.operation == 'add') {

      documenttypefederalregisteritems.createdby = this.userid;
      msg = "Record Added Successfully";
      this.documenttypefederalregisteritemsservice.Post(documenttypefederalregisteritems).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.documenttypefederalregisteritemsModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
              this.clearForm();
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      documenttypefederalregisteritems.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.documenttypefederalregisteritemsservice.Put(documenttypefederalregisteritems).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.documenttypefederalregisteritemsModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
              this.clearForm();
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.documenttypefederalregisteritemsForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.documenttypefederalregisteritemsForm.value.active = 1;
    } else {
      this.documenttypefederalregisteritemsForm.value.active = 0
    }
  }

  OpenConfirmTemplate(documenttypefederalregisteritems, template: TemplateRef<any>) {
    if (documenttypefederalregisteritems.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.documenttypefederalregisteritems = documenttypefederalregisteritems;

          this.Delete();

        }

      });

  }

  Delete() {
    var msg;
    if (this.documenttypefederalregisteritems.active == 0) {
      this.documenttypefederalregisteritems.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.documenttypefederalregisteritems.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.documenttypefederalregisteritems.modifiedby = this.userid;
    this.documenttypefederalregisteritemsservice.Delete(this.documenttypefederalregisteritems).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }

  hidePopup() {
    this.documenttypefederalregisteritemsModalRef.hide();
  }

  openDocumentTypeFederalRegisterItemsModal(template: TemplateRef<any>, type, documenttypefederalregisteritems?: DocumentTypeFederalRegisterItems) {

    this.operation = type

    if (type == 'update') {
      this.documenttypefederalregisteritemsForm.controls['documenttypefederalregisteritemsid'].setValue(documenttypefederalregisteritems.documenttypefederalregisteritemsid);
      this.documenttypefederalregisteritemsForm.controls['documenttypefederalregisteritems'].setValue(documenttypefederalregisteritems.documenttypefederalregisteritems);
      this.documenttypefederalregisteritemsForm.controls['active'].setValue(documenttypefederalregisteritems.active);
      this.documenttypefederalregisteritems = documenttypefederalregisteritems;
    }
    if (type == 'add') {
      this.documenttypefederalregisteritemsForm.controls['documenttypefederalregisteritemsid'].setValue(0);
      this.documenttypefederalregisteritemsForm.controls['documenttypefederalregisteritems'].setValue('');
      this.documenttypefederalregisteritemsForm.controls['active'].setValue(1);
    }
    this.documenttypefederalregisteritemsModalRef = this.modalService.show(template, this.config);

    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }

}
